import {useEffect, useRef, useState} from 'react';

type TurnstileApi = {
  render(element: HTMLElement, options: {sitekey: string; action: string; size: 'flexible'|'compact'; callback: (token: string) => void; 'expired-callback': () => void; 'error-callback': () => void}): string;
  remove(id: string): void;
};
declare global { interface Window {turnstile?: TurnstileApi} }
let loading: Promise<TurnstileApi> | undefined;
function loadWidget(): Promise<TurnstileApi> {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!loading) loading = new Promise<TurnstileApi>((resolve,reject) => {
    const script=document.createElement('script');
    const fail=()=>{clearTimeout(timeout);script.remove();reject(new Error('Unavailable'));};
    const timeout=setTimeout(fail,15000);
    script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async=true;script.defer=true;
    script.onload=()=>{clearTimeout(timeout);if(window.turnstile)resolve(window.turnstile);else fail();};
    script.onerror=fail;
    document.head.appendChild(script);
  }).catch(error=>{loading=undefined;throw error;});
  return loading;
}

export function SignupBotCheck({siteKey,action,reset,onToken}:{siteKey:string;action:'signup_start'|'signup_complete'|'account_recovery_request'|'quick_serve_start';reset:number;onToken:(token:string)=>void}) {
  const host=useRef<HTMLDivElement>(null),callback=useRef(onToken);
  callback.current=onToken;
  const [failed,setFailed]=useState(false);
  const [compact,setCompact]=useState(()=>window.matchMedia?.('(max-width: 420px)').matches??false);
  useEffect(()=>{
    const query=window.matchMedia?.('(max-width: 420px)');
    if(!query)return;
    const change=()=>setCompact(query.matches);
    query.addEventListener('change',change);
    return()=>query.removeEventListener('change',change);
  },[]);
  useEffect(()=>{
    let active=true,widget:string|undefined,api:TurnstileApi|undefined;
    callback.current('');setFailed(false);
    void loadWidget().then(loaded=>{
      if(!active||!host.current)return;
      api=loaded;
      widget=loaded.render(host.current,{sitekey:siteKey,action,size:compact?'compact':'flexible',
        callback:token=>{if(active){setFailed(false);callback.current(token);}},
        'expired-callback':()=>{if(active)callback.current('');},
        'error-callback':()=>{if(active){callback.current('');setFailed(true);}},
      });
    }).catch(()=>{if(active)setFailed(true);});
    return()=>{active=false;if(api&&widget!==undefined)api.remove(widget);};
  },[siteKey,action,reset,compact]);
  return <div className="signup-security"><div ref={host} aria-label="Signup security check"/>{failed&&<p role="alert">The security check could not load. Reload this page to try again.</p>}</div>;
}
